import { render, staticRenderFns } from "./editBasicProfile.vue?vue&type=template&id=eccc2700&scoped=true"
import script from "./editBasicProfile.vue?vue&type=script&lang=js"
export * from "./editBasicProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eccc2700",
  null
  
)

export default component.exports